module.exports = __webpack_public_path__ + "static/media/pirateiscrime.a3aafd73.gif";